import React, { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';

const COOKIE_KEY = 'voicebook_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() }));
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ accepted: false, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield className="w-8 h-8 text-sky-500 shrink-0 hidden sm:block" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-slate-800 mb-1">Informativa Cookie e Privacy</p>
          <p className="text-xs text-slate-600 leading-relaxed">
            Questo sito utilizza cookie tecnici necessari al funzionamento della piattaforma. 
            Non utilizziamo cookie di profilazione o di terze parti per finalita' pubblicitarie. 
            I dati personali sono trattati ai sensi del Regolamento UE 2016/679 (GDPR). 
            Consulta la nostra{' '}
            <a href="/privacy" className="text-sky-500 underline hover:text-sky-600">Informativa Privacy</a>.
          </p>
        </div>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={handleReject}
            className="flex-1 sm:flex-none px-4 py-2 text-sm text-slate-600 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
            data-testid="cookie-reject"
          >
            Rifiuta
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 sm:flex-none px-4 py-2 text-sm font-medium text-white bg-sky-500 rounded-lg hover:bg-sky-600 transition-colors"
            data-testid="cookie-accept"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
